import React, { useCallback, useEffect, useRef, useState } from "react";
import { Box, Tooltip } from "@mui/material";

// Single-line text that ellipsizes. When the full value does not fit, hover
// (or focus) shows it in a tooltip. Use anywhere Trust Center truncates text.
const TruncatedText = ({ value, sx }) => {
  const ref = useRef(null);
  const [overflows, setOverflows] = useState(false);

  const measure = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    setOverflows(el.scrollWidth > el.clientWidth + 1);
  }, []);

  useEffect(() => {
    measure();
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [measure, value]);

  const text = (
    <Box
      ref={ref}
      component="span"
      onMouseEnter={measure}
      sx={{
        display: "block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        minWidth: 0,
        ...sx,
      }}
    >
      {value}
    </Box>
  );

  if (!overflows || value == null || value === "") return text;

  return (
    <Tooltip title={value} arrow enterDelay={400}>
      {text}
    </Tooltip>
  );
};

export default TruncatedText;
